import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Modal, Dialog } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import { firebase } from '../../../model/firebase/firebase';
import { CompanyDestiny, StudentDestiny } from '../utils/mailsHeredados';

export const TextDialog = ({ action, close, open }) => {
  const [text, setText] = useState('');

  const handleChange = (e) => {
    const { value } = e.target;
    setText(value);
  };

  const SaveText = () => {
    action('p', text);
    close('ModalText');
    setText('');
  };

  return (
    <Dialog open={open} onClose={() => close('ModalText')} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Agrega texto al cuerpo del mensaje</DialogTitle>
      <DialogContent>
        <DialogContentText>Puedes agregar más de un bloque de texto al cuerpo del mensaje</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Texto"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={text}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close('ModalText')} color="primary">
          Cancelar
        </Button>
        <Button onClick={SaveText} color="primary">
          Agregar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ImageDialog = ({ action, close, open }) => {
  const [state, setState] = useState({
    loadingImage: false,
    progress: 0,
    startUpload: false,
  });
  const platform = useSelector((state) => state.platform);
  const [image, setImage] = useState('');

  const SaveText = () => {
    action('img', image);
    close('ModalImage');
    setImage('');
  };
  const handleUploadStart = () => {
    setState((prevState) => ({ ...prevState, loadingImage: true, progress: 0, startUpload: true }));
  };
  const handleProgress = (progress) => setState((prevState) => ({ ...prevState, progress }));
  const handleUploadError = (error) => {
    setState((prevState) => ({ ...prevState, isUploading: false }));
  };
  const handleUploadSuccess = (file) => {
    setState((prevState) => ({ ...prevState, progress: 100, loadingImage: false, isUploading: false }));
    firebase
      .storage()
      .ref(`platforms/${platform.platformName}/mailing/images`)
      .child(file)
      .getDownloadURL()
      .then((url) => {
        setImage(url);
      });
  };

  return (
    <Dialog open={open} onClose={() => close('ModalImage')} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" style={{ fontSize: '1.45rem' }}>
        Agrega texto al cuerpo del mensaje
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ fontSize: '1.3rem' }}>
          Puedes agregar más de una imagen al cuerpo del mensaje
        </DialogContentText>
        <CustomUploadButton
          accept="images/*"
          filename={dayjs().valueOf()}
          storageRef={firebase.storage().ref(`platforms/${platform.platformName}/mailing`).child('images')}
          onUploadStart={handleUploadStart}
          onUploadError={handleUploadError}
          onUploadSuccess={handleUploadSuccess}
          onProgress={handleProgress}>
          <p
            style={{
              cursor: 'pointer',
              backgroundColor: '#5373FC',
              fontSize: '1.2rem',
              margin: 'auto',
              fontWeight: '800',
              color: 'white',
              padding: '5px 15px',
              borderRadius: 4,
            }}>
            Seleccionar imagen
          </p>
        </CustomUploadButton>
      </DialogContent>
      {!state.loadingImage ? (
        <DialogActions>
          <Button onClick={() => close('ModalImage')} color="primary">
            Cancelar
          </Button>
          <Button onClick={SaveText} color="primary">
              Agregar
            </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};

export const LinkDialog = ({ action, close, open }) => {
  const [link, setLink] = useState({
    link: '',
    hiperText: '',
  });
  const handleChange = (e) => {
    const {target} = e;
    const {name} = target;
    const {value} = target;
    setLink((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const SaveText = () => {
    action('a', link.link, link.hiperText);
    close('ModalLink');
    setLink((prevState) => ({ ...prevState, link: '', hiperText: '' }));
  };

  return (
    <Dialog open={open} onClose={() => close('ModalLink')} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Agrega texto al cuerpo del mensaje</DialogTitle>
      <DialogContent>
        <DialogContentText>Puedes agregar más de un link al cuerpo del mensaje</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="hiperText"
          label="Encabezado"
          name="hiperText"
          type="text"
          fullWidth
          value={link.hiperText}
          onChange={handleChange}
        />
        <TextField
          autoFocus
          margin="dense"
          id="link"
          label="Link o url"
          name="link"
          type="text"
          fullWidth
          value={link.link}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close('ModalLink')} color="primary">
          Cancelar
        </Button>
        <Button onClick={SaveText} color="primary">
          Agregar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const AddUsersDestiny = ({ open, onClose, sendMail }) => {
  const platform = useSelector((state) => state.platform);
  const users = useSelector((state) => state.users);
  const [state, setState] = useState({
    users,
    multiSend: [],
  });

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <div style={{ width: '80%', position: 'relative', margin: '5% auto', overflow: 'auto', padding: '20px' }}>
        <StudentDestiny data={users} platform={platform} multisend={state.multiSend} sendEmail={sendMail} />
      </div>
    </Modal>
  );
};

export const AddCompanyDestiny = ({ open, onClose, sendMail }) => {
  const platform = useSelector((state) => state.platform);
  const companies = useSelector((state) => state.companies);
  const [state, setState] = useState({
    companies,
    multiSend: [],
  });

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="customized-dialog-title">
      <div style={{ width: '60vw', position: 'relative', margin: '5% auto', overflow: 'auto', padding: '20px' }}>
        <CompanyDestiny data={companies} platform={platform} multisend={state.multiSend} sendEmail={sendMail} />
      </div>
    </Modal>
  );
};
